import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
	name: 'month'
})
export class MonthPipe implements PipeTransform {

	transform(unix:number, capitalized = true) : string {
		if (!unix)
			return "";
		
		let month = moment(unix).month();
		let m : string;

		switch (month) {
			case 0 : {
				m = "enero";
				break;
			}
			case 1 : {
				m = "febrero";
				break;
			}
			case 2 : {
				m = "marzo";
				break;
			}
			case 3 : {
				m = "abril";
				break;
			}
			case 4 : {
				m = "mayo";
				break;
			}
			case 5 : {
				m = "junio";
				break;
			}
			case 6 : {
				m = "julio";
				break;
			}
			case 7 : {
				m = "agosto";
				break;
			}
			case 8 : {
				m = "septiembre";
				break;
			}
			case 9 : {
				m = "octubre";
				break;
			}
			case 10 : {
				m = "noviembre";
				break;
			}case 11 : {
				m = "diciembre";
				break;
			}
			default : {
				m = "";
			}
		}
		if (capitalized)
			m = m.charAt(0).toUpperCase() + m.slice(1);
		
		return m;
	}

}
